import { useState, useEffect } from "react";
import "./NewsCarousel.css";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import NoImage from "../../assets/NoImage.png"; // 默认图片路径
import axiosInstance from "../axiosInstance";
import { API } from "../../API";

const NewsCarousel = () => {
  const [startIndex, setStartIndex] = useState(0);
  const [newsData, setNewsData] = useState([]);
  const [itemsVisible, setItemsVisible] = useState(4); // 控制显示卡片数
  const navigate = useNavigate();

  const maxIndex = Math.max(newsData.length - itemsVisible, 0);
  const currentItems = newsData.slice(startIndex, startIndex + itemsVisible);

  // 根据窗口宽度动态设置 itemsVisible
  const updateVisibleItems = () => {
    const width = window.innerWidth;
    if (width <= 480) setItemsVisible(2);
    else if (width <= 768) setItemsVisible(2);
    else if (width <= 1200) setItemsVisible(3);
    else setItemsVisible(4);
  };

  useEffect(() => {
    updateVisibleItems();
    window.addEventListener("resize", updateVisibleItems);
    return () => window.removeEventListener("resize", updateVisibleItems);
  }, []);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await axiosInstance.get(`${API.NEWS}/news/page`, {
          params: { pageNum: 1, pageSize: 20 }, // 拉取更多数据供滚动
        });
        setNewsData(res.data?.records || []);
      } catch (err) {
        console.error("新闻获取失败", err);
      }
    };

    fetchNews();
  }, []);

  const handlePrev = () => {
    setStartIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setStartIndex((prev) => Math.min(prev + 1, maxIndex));
  };

  const handleMoreNews = () => {
    navigate("/News");
  };

  const handleCardClick = (newsId) => {
    navigate(`/News/${newsId}`);
  };

  return (
    <div className="newsCarousel">
      <div className="newsHeader">
        <h2>NEWS CENTER</h2>
        <button className="moreNewsButton" onClick={handleMoreNews}>MORE NEWS</button>
      </div>

      <div className="newsList">
        {currentItems.map((item, idx) => (
        //   <div className="newsCardWithBg" onClick={() => handleCardClick(item.newsId)}>
        //     <div className="cardContent">
        //       <p className="cardDate">
        //         {item.newsDate
        //           ? new Date(item.newsDate).toLocaleDateString(undefined, {
        //               month: "short",
        //               day: "2-digit",
        //               year: "numeric"
        //             })
        //           : ""}
        //       </p>
        //       <h4 className="cardTitle">{item.newsTitle}</h4>
        //     </div>
        //     <div
        //       className="cardBackground"
        //       style={{
        //         backgroundImage: `url(${item.newsCover || require('../../assets/NoImage.png')})`
        //       }}
        //     />
        // </div>
        <div className="newsCardWithBg" onClick={() => handleCardClick(item.newsId)}>
          <img
            className="cardImage"
            src={item.newsCover || NoImage} // 使用默认图片
            alt="news"
          />
          <div className="cardContent">
          <p className="cardDate">
            {item.gmtModified
              ? new Date(item.gmtModified).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "short",
                  day: "2-digit",
                })
              : ""}
          </p>
            <h4 className="cardTitle">{item.newsTitle}</h4>
          </div>
        </div>
        ))}
      </div>

      <div className="newsControls">
        <button className="arrowButton" onClick={handlePrev} disabled={startIndex === 0}>
          <LeftOutlined />
        </button>
        <button className="arrowButton" onClick={handleNext} disabled={startIndex >= maxIndex}>
          <RightOutlined />
        </button>
        <div className="progressBarWrapper">
          <div
            className="progressBar"
            style={{ width: `${((startIndex + 1) / (newsData.length - itemsVisible + 1)) * 100}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default NewsCarousel;